import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { getHdGetFightingRank } from "@/api/gmtool/packageCode";
import { gmTool, gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "effectiveness",
  mixins: [gmTool, gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      tableData: []
    };
  },
  created: function created() {},
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.paramsData.page = e;
      this.reqLoading = true;
      getHdGetFightingRank(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this.tableData = JSON.stringify(res.data) != '[]' ? res.data.data : [];
          _this.total = res.data.total; // this.$nextTick(() => {
          //   this.getTableRight()
          // })
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.searchClick(1);
    },
    exportdata: function exportdata() {
      var _this2 = this;

      getHdGetFightingRank(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.status == 200) {
          var columns = [{
            label: _this2.$t('roleId'),
            prop: 'role_id'
          }, {
            label: _this2.$t('fightingPower'),
            prop: 'fighting'
          }, {
            label: _this2.$t('level'),
            prop: 'level'
          }, {
            label: _this2.$t('lastLoginTime'),
            prop: 'last_login_time'
          }];

          _this2.$export.excel({
            columns: columns,
            data: res.data,
            title: _this2.$route.meta.title
          });
        }
      });
    }
  }
};